
    import '/opt/buildhome/repo/components/thought-chain/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["thought-chain-demo-basic","thought-chain-demo-size","thought-chain-demo-status","thought-chain-demo-collapsible","thought-chain-demo-customization","thought-chain-demo-nested","thought-chain-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/components/thought-chain/index.zh-CN.md?type=demo')
};